const ArrowDown = () => {
    return (
        <svg
            width='17'
            height='33'
            viewBox='0 0 17 33'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <line
                y1='-0.5'
                x2='22.6667'
                y2='-0.5'
                transform='matrix(8.74228e-08 1 1 -8.74227e-08 9.44434 0)'
                stroke='#23B3E5'
            />
            <path
                d='M8.93301 31.3613C8.74056 31.6947 8.25944 31.6947 8.06699 31.3613L1.5718 20.1113C1.37935 19.778 1.61991 19.3613 2.00481 19.3613H14.9952C15.3801 19.3613 15.6207 19.778 15.4282 20.1113L8.93301 31.3613Z'
                fill='#23B3E5'
            />
        </svg>
    );
};

export default ArrowDown;
